/**
 * Resolve o header (título/subtítulo) de uma view a partir do nome da rota
 * atual e da lista de rotas de abas do módulo — GENÉRICO, serve qualquer módulo.
 *
 * Replica o casamento que a `nav-bar-navigation.vue` faz (computed `activeRoute`
 * → método `isSelected`): casamento por PREFIXO do nome da rota
 * (`routeName.indexOf(route.name) === 0`), primeiro match vence. Assim uma
 * subrota (ex.: `crm.relationship.clients`) herda o header da aba
 * (`crm.relationship`), igual ao que o Nav 2026 exibe.
 *
 * @param {String} routeName - nome da rota atual (`this.$route.name`)
 * @param {Array<{name: String, title?: String, subtitle?: String}>} routes -
 *   rotas de abas do módulo (ex.: `crmRoutes()`)
 * @returns {{ title: String, subtitle: String }}
 */
export function resolveRouteHeader(routeName, routes) {
  const empty = { title: '', subtitle: '' }
  if (!routeName || !Array.isArray(routes)) return empty

  const match = routes.find(
    (route) => route && route.name && routeName.startsWith(route.name)
  )
  if (!match) return empty

  return {
    title: match.title || '',
    subtitle: match.subtitle || '',
  }
}
